import _classCallCheck from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/fitzwage/Coding/notSoTrivialPursuit/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * Returns an extended version of `Swal` containing `params` as defaults.
 * Useful for reusing Swal configuration.
 *
 * For example:
 *
 * Before:
 * const textPromptOptions = { input: 'text', showCancelButton: true }
 * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
 * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
 *
 * After:
 * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
 * const {value: firstName} = await TextPrompt('What is your first name?')
 * const {value: lastName} = await TextPrompt('What is your last name?')
 *
 * @param mixinParams
 */
export function mixin(mixinParams) {
  var MixinSwal =
  /*#__PURE__*/
  function (_this) {
    _inherits(MixinSwal, _this);

    function MixinSwal() {
      _classCallCheck(this, MixinSwal);

      return _possibleConstructorReturn(this, _getPrototypeOf(MixinSwal).apply(this, arguments));
    }

    _createClass(MixinSwal, [{
      key: "_main",
      value: function _main(params) {
        return _get(_getPrototypeOf(MixinSwal.prototype), "_main", this).call(this, Object.assign({}, mixinParams, params));
      }
    }]);

    return MixinSwal;
  }(this);

  return MixinSwal;
}